import { FiClock } from "react-icons/fi";
import CustomCalendar from "../ui/CustomCalendar";

interface DateTimeStepProps {
  selectedDate: string;
  selectedTime: string;
  timeOptions: string[];
  loadingSlots: boolean;
  accentColor: string;
  backgroundColor?: string;
  onDateChange: (date: string) => void;
  onTimeChange: (time: string) => void;
}

function DateTimeStep({
  selectedDate,
  selectedTime,
  timeOptions,
  loadingSlots,
  accentColor,
  backgroundColor,
  onDateChange,
  onTimeChange,
}: DateTimeStepProps) {
  return (
    <div className="space-y-5 animate-fadeIn">
      <div className="text-center mb-6">
        <h4 className="text-lg font-semibold text-black dark:text-white">
          Data e Horário
        </h4>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
          Quando você gostaria de agendar?
        </p>
      </div>

      <div>
        <label className="mb-3 block text-sm font-medium text-black dark:text-white">
          Selecione a data
        </label>
        <div className="overflow-hidden rounded-xl border border-stroke bg-white p-3 dark:border-strokedark dark:bg-boxdark">
          <CustomCalendar
            onChange={(date) => onDateChange(date.toISOString())}
            value={selectedDate}
            backgroundColor={backgroundColor}
            minDate={new Date()}
          />
        </div>
      </div>

      <div>
        <label className="mb-3 block text-sm font-medium text-black dark:text-white">
          Escolha o horário
        </label>
        {loadingSlots ? (
          <div className="flex items-center justify-center py-8">
            <div className="h-8 w-8 animate-spin rounded-full border-2 border-gray-300 border-t-transparent" />
            <span className="ml-3 text-sm text-gray-500">
              Carregando horários disponíveis...
            </span>
          </div>
        ) : timeOptions.length === 0 ? (
          <div className="rounded-lg border border-stroke bg-gray-50 p-4 text-center dark:border-strokedark dark:bg-meta-4">
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Não há horários disponíveis para esta data.
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-3 sm:grid-cols-4 gap-2 max-h-64 overflow-y-auto">
            {timeOptions.map((time) => (
              <button
                key={time}
                type="button"
                onClick={() => onTimeChange(time)}
                className={`rounded-lg border-2 py-3 text-sm font-medium transition-all ${
                  selectedTime === time
                    ? "shadow-md"
                    : "border-stroke hover:border-gray-300 dark:border-strokedark dark:hover:border-gray-600"
                }`}
                style={
                  selectedTime === time
                    ? {
                        borderColor: accentColor,
                        backgroundColor: `${accentColor}10`,
                        color: accentColor,
                      }
                    : {}
                }
              >
                <FiClock size={16} className="mx-auto mb-1" />
                {time}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default DateTimeStep;
